<script>
    import Shared     from './Shared.svelte'
    import FieldError from '../../../shared/FieldError.svelte'

    export let domain
    export let place
    export let active
    
    const constraints = {
        name: {
            presence: {
                allowEmpty: false,
                message: "campo obrigatório"
            }
        },
        email: {
            presence: {
                allowEmpty: false,
                message: "campo obrigatório"
            },
            email: {
                 message: "email inválido"
            }
        },
        pin: {
            custom: {
                message: "campo obrigatório"
            }
        }
    }

    let config = {
        kind      : 'email',
        name      : active && active.name      || place.responsible, 
        email     : active && active.email     || place.email,
        anonymous : active && active.anonymous,
        pin       : active && active.pin,
    }

    //$: errors = validate(obj, constraints) || {}
</script>
<Shared type="email" {domain} {place} {config} {constraints} let:working let:errors>
    <div class="field" 
         class:disabled={working} 
         class:error={errors.name}>
        <label>Responsável</label>
        <input bind:value={config.name}>
    </div>
    <FieldError property={errors.name} />
    <div class="field" 
         class:disabled={working}
         class:error={errors.email}>
        <label>Email</label>
        <input bind:value={config.email}>
    </div>
    <FieldError property={errors.email} />
    <div class="inline fields">
        <div class="field">
            <div class="ui toggle big checkbox">
                <input type="checkbox" bind:checked={config.anonymous}>
                <label>Permitir respostas via PIN</label>
            </div>
        </div>
        <div class="five wide field" 
             class:disabled={working || !config.anonymous}
             class:error={errors.pin}>
            <label>PIN</label>
            <input bind:value={config.pin}>
        </div>
    </div>
</Shared>